import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import {
    Row,
    Col,
    Container,
    Form,
    InputGroup,
    Button,
    Tab,
    Nav,
    ButtonToolbar,
    ToggleButton,
    ToggleButtonGroup,
    Image,
    OverlayTrigger,
    Tooltip
} from 'react-bootstrap';
import ItemsCarousel from './common/ItemsCarousel';
import ChooseAddressCard from './common/ChooseAddressCard';
import CheckoutItem from './common/CheckoutItem';
import AddAddressModal from './modals/AddAddressModal';
import Icofont from 'react-icofont';
import { liefershops, createOrder, capturePayment } from "../utils";
import { withRouter } from 'react-router-dom';
import { Helmet } from "react-helmet";

class Checkout extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAddressModal: false,
            addresses: [],
            productItems: [],
            currentAddress: {},
            lastRestaurant: {},
            totalPrice: 0,
            checkOutItemRefs: {},
            lieferkosten: 0.00,
            pfandPrice: 0,
            payment: "paypal",
            token: null,
            payerId: null,
            geschenkAktionen: [],
            paymentError: null,
            paymentBusy: false,
        };

        this.hideAddressModal = this.hideAddressModal.bind(this);
        this.onAddressChoose = this.onAddressChoose.bind(this);
        this.loadAddresses = this.loadAddresses.bind(this);
        this.onAddressRemove = this.onAddressRemove.bind(this);
        this.loadProducts = this.loadProducts.bind(this);
        this.getQty = this.getQty.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.sendOrder = this.sendOrder.bind(this);

        this.loadAddresses();
        this.loadProducts();
    }

    componentDidMount() {
        this.getTokenFromURL();
        const lastRestaurant = JSON.parse(localStorage.getItem("last-restaurant") || "{}");
        if (lastRestaurant.id) {
            fetch(liefershops(`api/v1/geschenk-aktion/?partner_id=${lastRestaurant.id}`))
                .then((response) => response.json())
                .then((data) => {
                    if (Array.isArray(data)) {
                        this.setState({ geschenkAktionen: data });
                    }
                })
                .catch(() => {});
        }
    }

    getTokenFromURL() {
        const queryParams = new URLSearchParams(this.props.location.search);
        const token = queryParams.get('token');
        const payerId = queryParams.get('PayerID');

        if (payerId && payerId !== this.state.payerId) {
            this.setState({ payerId })
        }

        if (token && token !== this.state.token) {
            this.setState({ token });
        }

        if (token && !payerId) {
            this.setState({ token: null });
        } else if (token && payerId) {
            setTimeout(() => {
                this.sendOrder();
            }, 200);
        }
    }

    hideAddressModal() {
        this.loadAddresses();

        this.setState({ showAddressModal: false });
    }

    onAddressChoose(addressData) {

        localStorage.setItem("deliveryAddress", JSON.stringify(addressData));

        this.setState({ currentAddress: addressData });
    }

    loadAddresses() {
        const addresses = JSON.parse(localStorage.getItem("addresses") || "[]");
        const state = this.state;

        state.addresses = [];

        let iter = 0;

        addresses.forEach(element => {
            iter++;

            const cardAddress = (
                <ChooseAddressCard
                    title={`Adresse ${iter}`}
                    icoIcon='home'
                    iconclassName='icofont-3x'
                    address={`${element.street} ${element.houseNumber}, ${element.zipCode} ${element.city} ${element.region}`}
                    onDeliverHere={this.onAddressChoose}
                    onRemoveAddress={this.onAddressRemove}
                    addressData={element}
                />
            );

            this.state.addresses.push(cardAddress);
        });

        this.setState(state);
    }

    onAddressRemove(addressData) {
        let addresses = JSON.parse(localStorage.getItem("addresses") || "[]");

        const indexToRemove = addresses.findIndex((item) => item.id === addressData.id);

        if (indexToRemove !== -1) {
            addresses.splice(indexToRemove, 1);
        }

        localStorage.setItem("addresses", JSON.stringify(addresses));

        this.loadAddresses();

        this.setState({ currentAddress: {} });
    }

    loadProducts() {
        const plz = localStorage.getItem("plz");
        const lastRestaurant = JSON.parse(localStorage.getItem("last-restaurant") || "{}");
        if (Object.keys(lastRestaurant).length === 0) {
            return;
        }

        const state = this.state;
        state.lastRestaurant = lastRestaurant;

        const matchedZip = lastRestaurant.zip_codes?.find(item => item.postleitzahl === plz);
        const lieferkosten = matchedZip ? parseFloat(matchedZip.lieferkosten) : 0;
        state.lieferkosten = lieferkosten;

        const products = JSON.parse(localStorage.getItem(`restaurant-products-${lastRestaurant.id}`) || "{}");

        for (let key in products) {
          products[key].getPricePfand = function () {
            return this.pricepfand;
          };
        }

        if (Object.keys(products).length === 0) {
            return;
        }

        state.productItems = [];

        for (let product in products) {
            state.checkOutItemRefs[product] = React.createRef();

            const productItem = (
                <CheckoutItem
                    itemName={product}
                    nummer={products[product].nummer}
                    price={products[product].price}
                    priceUnit="€"
                    id={1}
                    product={products[product]}
                    qty={products[product].amount}
                    show={true}
                    minValue={0}
                    maxValue={40}
                    getValue={this.getQty}
                    addFun={this.onAdd}
                    removeFun={this.onRemove}
                    deleteFun={this.onDelete}
                    ref={state.checkOutItemRefs[product]}
                />
            );

            state.productItems.push(productItem);
        }

        this.setState(state);

        setTimeout(() => {
            this.updateTotalPrice();
        }, 200);
    }

    getTotalPrice() {
        // const state = this.state;
        // const lastRestaurant = state.lastRestaurant;
        //
        // const rabatt = lastRestaurant.rabatt || 0;
        // const rabattFestAb = parseFloat(lastRestaurant.rabatt_fest_ab) || 0;
        // const rabattFest = parseFloat(lastRestaurant.rabatt_fest) || 0;
        //
        // if (rabattFestAb > 0 && state.totalPrice >= rabattFestAb) {
        //     return state.totalPrice - state.totalPrice * rabattFest / 100;
        // }
        //
        // const totalPrice = (state.totalPrice - state.totalPrice * rabatt / 100) + this.state.lieferkosten;
        //
        //
        // return totalPrice.toFixed(2);

        const state = this.state;
        const lastRestaurant = state.lastRestaurant;

        const rabatt = lastRestaurant.rabatt || 0; // Знижка
        const rabattFestAb = parseFloat(lastRestaurant.rabatt_fest_ab) || 0; // Умови для RabattFest
        const rabattFest = parseFloat(lastRestaurant.rabatt_fest) || 0;

        // Початкова сума без знижок (Summe)
        let totalPrice = state.totalPrice;

        // Якщо RabattFest застосовується
        if (rabattFestAb > 0 && state.totalPrice >= rabattFestAb) {
            totalPrice -= totalPrice * rabattFest / 100;
        } else {
            totalPrice -= totalPrice * rabatt / 100;
        }

        // Окремо додаємо Pfand, яке не підлягає знижці
        totalPrice += state.pfandPrice;

        // Тепер додаємо доставку
        totalPrice += state.lieferkosten;

        return totalPrice.toFixed(2);
    }

    getDiscount() {
        // const state = this.state;
        // const discount = state.totalPrice - this.getTotalPrice() + this.state.lieferkosten;
        //
        // return discount.toFixed(2);

        const state = this.state;
        const warenTotal = state.totalPrice;
        const pfand = parseFloat(state.pfandPrice) || 0;

        const rabatt = parseFloat(state.lastRestaurant.rabatt) || 0;
        const rabattFestAb = parseFloat(state.lastRestaurant.rabatt_fest_ab) || 0;
        const rabattFest = parseFloat(state.lastRestaurant.rabatt_fest) || 0;

        let discountedTotal = warenTotal;

        if (rabattFestAb > 0 && warenTotal >= rabattFestAb && rabattFest !== 0) {
            discountedTotal = warenTotal - (warenTotal * Math.abs(rabattFest) / 100);
        } else {
            discountedTotal = warenTotal - (warenTotal * Math.abs(rabatt) / 100);
        }

        const discount = warenTotal - discountedTotal;
        return discount.toFixed(2);

    }

    updateTotalPrice() {
        // let totalPrice = 0;
        //
        // Object.values(this.state.checkOutItemRefs).forEach(ref => {
        //     if (ref.current) {
        //         const currentCheckOut = ref.current;
        //         totalPrice += parseFloat(currentCheckOut.getTotalPrice());
        //     }
        // });
        //
        // this.setState({ totalPrice });

        let totalPrice = 0;    // Ціна товарів зі знижкою
        let pfandPrice = 0;    // Сума Pfand, не підлягає знижці

        Object.values(this.state.checkOutItemRefs).forEach(ref => {
            if (ref.current) {
                const currentCheckOut = ref.current;

                // Одержуємо загальну ціну для товару (ціна товару без Pfand)
                const fullPrice = parseFloat(currentCheckOut.getTotalPrice());

                // Одержуємо ціну Pfand
                const pfand = parseFloat(currentCheckOut.getTotalPfandPrice() || 0);

                // Додаємо ціну товару до загальної суми
                totalPrice += fullPrice;

                // Додаємо Pfand окремо, не враховуючи його в товарній ціні
                pfandPrice += pfand;
            }
        });

        // Оновлюємо state, де totalPrice вже містить ціну товарів без Pfand, а pfandPrice містить суму Pfand
        this.setState({ totalPrice, pfandPrice });
    }

    onAdd(product) {
        const lastRestaurant = JSON.parse(localStorage.getItem("last-restaurant") || "{}");

        if (Object.keys(lastRestaurant).length === 0) {
            return;
        }

        const products = JSON.parse(localStorage.getItem(`restaurant-products-${lastRestaurant.id}`) || "{}");
        if (Object.keys(products).length === 0) {
            return;
        }

        products[product].amount += 1;

        localStorage.setItem(`restaurant-products-${lastRestaurant.id}`, JSON.stringify(products));

        setTimeout(() => {
            this.updateTotalPrice();
        }, 100);
    }

    onRemove(product) {
        const lastRestaurant = JSON.parse(localStorage.getItem("last-restaurant") || "{}");

        if (Object.keys(lastRestaurant).length === 0) {
            return;
        }

        const products = JSON.parse(localStorage.getItem(`restaurant-products-${lastRestaurant.id}`) || "{}");
        if (Object.keys(products).length === 0) {
            return;
        }

        products[product].amount -= 1;

        if (products[product].amount === 0) {
            delete products[product];
        }

        localStorage.setItem(`restaurant-products-${lastRestaurant.id}`, JSON.stringify(products));

        setTimeout(() => {
            this.updateTotalPrice();
        }, 100);
    }

    onDelete(product) {
        const lastRestaurant = JSON.parse(localStorage.getItem("last-restaurant") || "{}");

        if (Object.keys(lastRestaurant).length === 0) {
            return;
        }

        const products = JSON.parse(localStorage.getItem(`restaurant-products-${lastRestaurant.id}`) || "{}");
        if (Object.keys(products).length === 0) {
            return;
        }

        delete products[product];
        delete this.state.checkOutItemRefs[product];

        localStorage.setItem(`restaurant-products-${lastRestaurant.id}`, JSON.stringify(products));

        this.loadProducts();

        setTimeout(() => {
            this.updateTotalPrice();
        }, 100);
    }

    getQty(id, quantity) {

    }

    setPayment(payment) {
        this.setState({ payment: payment });
    }

    async sendOrder() {
        const token = this.state.token
        const payerId = this.state.payerId

        const state = this.state;
        const lastRestaurant = JSON.parse(localStorage.getItem("last-restaurant") || "{}");

        const curr_email = JSON.parse(localStorage.getItem("deliveryAddress"))?.email;
        const curr_name = JSON.parse(localStorage.getItem("deliveryAddress"))?.firstName;
        const curr_lastname = JSON.parse(localStorage.getItem("deliveryAddress"))?.lastName;
        const curr_zip = JSON.parse(localStorage.getItem("deliveryAddress"))?.zipCode;
        const curr_city = JSON.parse(localStorage.getItem("deliveryAddress"))?.city;
        const curr_street = JSON.parse(localStorage.getItem("deliveryAddress"))?.street;
        const curr_house = JSON.parse(localStorage.getItem("deliveryAddress"))?.houseNumber;
        const curr_phone = JSON.parse(localStorage.getItem("deliveryAddress"))?.phone;
        const curr_stockwerk = JSON.parse(localStorage.getItem("deliveryAddress"))?.stockwerk;
        const curr_message = JSON.parse(localStorage.getItem("deliveryAddress"))?.message;

        const getOrderDataFromLocalStorage = () => {

            const all_products = JSON.parse(localStorage.getItem(`restaurant-products-${lastRestaurant.id}`) || "{}");
            const partner = parseInt(lastRestaurant.id) || 0;

            const products = [];
            const status = "erstellt";
            const zahlungTyp = this.state.payment || "unknown";
            const email = curr_email || "user@example.com";
            const vorname = curr_name || "string";
            const nachname = curr_lastname || "string";
            const postleitzahl = curr_zip || "string";
            const stadt = curr_city || "string";
            const strasse = curr_street || "string";
            const hausnummer = curr_house || "string";
            const stockwerk = curr_stockwerk || "string";
            const telefonnummer = curr_phone || "string";
            const nachricht = curr_message || "string";
            const preis = state.totalPrice.toFixed(2) || "0.00";
            const rabatt = lastRestaurant.rabatt || 0;
            const rabattFestAb = lastRestaurant.rabatt_fest_ab || "0";
            const rabattFest = lastRestaurant.rabatt_fest || "0";
            const lieferkosten = this.state.lieferkosten || "0";
            const preisGesamt = this.getTotalPrice() || "0";

            // Формуємо об'єкт JSON
            const orderData = {
                products,
                status,
                zahlung_typ: zahlungTyp,
                email,
                vorname,
                nachname,
                postleitzahl,
                stadt,
                strasse,
                stockwerk,
                hausnummer,
                telefonnummer,
                nachricht,
                preis,
                rabatt,
                rabatt_fest_ab: rabattFestAb,
                rabatt_fest: rabattFest,
                lieferkosten,
                preis_gesamt: preisGesamt,
                partner
            };

            const processedProducts = Object.values(all_products).map((product) => {
                const extrasList = product.extras || [];
                // Option-group selections (Beilage, Sauce, Mozzarella-Rand, ...).
                // These are already priced into the basket total shown to the
                // customer, so they must travel with the order and with the
                // PayPal line items - otherwise PayPal charges less than the
                // displayed total and the kitchen never learns what was chosen.
                const zusaetzeList = product.selectedZusaetze || [];
                const groesse = product.selectedGroesse
                    ? `${product.selectedGroesse.groesse || ''}${product.selectedGroesse.einheit ? ' ' + product.selectedGroesse.einheit : ''}`.trim()
                    : null;

                // Zusaetze are persisted through the same relation as extras
                // (BestellungProduktZusatzModel), so merging them here makes
                // them show up on the kitchen receipt AND be charged by PayPal.
                // Previously they were dropped entirely on both counts.
                const mergedExtras = [
                    ...extrasList.map((extra) => ({
                        name: extra.name,
                        preis: parseFloat(extra.price * extra.amount).toFixed(2),
                    })),
                    ...zusaetzeList.map((z) => ({
                        name: z.name,
                        preis: parseFloat(z.preis || 0).toFixed(2),
                    })),
                ];

                return {
                    preis: parseFloat(product.price),
                    name: product.name,
                    groesse: groesse || null,
                    anzahl: parseFloat(product.amount),
                    produkt: product.id,
                    preis_pfand: parseFloat(product.pricepfand),
                    steuer_prozent: parseInt(product.steuer_prozent),
                    extras: mergedExtras.length > 0 ? mergedExtras : null,
                };
            });

            orderData.products = processedProducts;

            return orderData;
        };

        const orderData = getOrderDataFromLocalStorage();

        if (orderData.zahlung_typ === "bar") {
            localStorage.removeItem("deliveryAddress");
            localStorage.removeItem("last-restaurant");
            localStorage.removeItem(`restaurant-products-${lastRestaurant.id}`);
            if (parseFloat(orderData.preis_gesamt) > 0) {
                fetch(liefershops('api/v1/order/'), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(orderData)
                }).then(response => {
                    window.location.href = "/thanks"
                });
            }
        } else if (orderData.zahlung_typ === "paypal" && token === null && payerId === null) {
            // Never fail silently here. Previously any PayPal problem was only
            // written to console.error, so the customer pressed "Bezahlen" and
            // absolutely nothing happened, with no way to tell why.
            this.setState({ paymentError: null, paymentBusy: true });
            try {
                const approveUrl = await createOrder(orderData, lastRestaurant.name, this.getDiscount());
                window.location.href = approveUrl; // Перенаправлення на PayPal
            } catch (error) {
                console.error("PayPal create-order failed:", error);
                this.setState({
                    paymentBusy: false,
                    paymentError:
                        "Die Online-Zahlung ist derzeit nicht verfügbar. Bitte versuchen Sie es erneut oder wählen Sie „Bar“ als Zahlungsart.",
                });
            }
        } else if (orderData.zahlung_typ === "paypal" && token && payerId) {
            capturePayment(token).then(response => {
                localStorage.removeItem("deliveryAddress");
                localStorage.removeItem("last-restaurant");
                localStorage.removeItem(`restaurant-products-${lastRestaurant.id}`);
                if (parseFloat(orderData.preis_gesamt) > 0) {
                    fetch(liefershops('api/v1/order/'), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(orderData)
                    }).then(response => {
                        window.location.href = "/thanks"
                    });
                }
            })
        }
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>Bestellen Sie leckeres Essen sicher und einfach mit Liefershops.de</title>
                    <meta name="description" content="Sichere und einfache Zahlungsmöglichkeiten für Ihre Bestellungen. Zahlen Sie bequem online und lassen Sie sich Ihre Gerichte direkt nach Hause liefern mit Liefershops.de" />
                    <meta name="keywords" content="Online bezahlen, sichere Zahlung, Zahlungsmethoden, Bar, PayPal, schnelle Bestellung, Essenslieferung in Berlin" />
                    <meta property="og:title" content="Bezahlen Sie Ihre Bestellung sicher und schnell mit Liefershops.de in Berlin" />
                    <meta property="og:description" content="Nutzen Sie einfache und sichere Zahlungsmethoden für Ihre Bestellung. Wählen Sie die bequemste Zahlungsoption und genießen Sie Ihre Mahlzeit zu Hause mit Liefershops.de" />
                    <meta property="og:type" content="website" />
                    <meta name="robots" content="index, follow" />
                </Helmet>
                <section className="offer-dedicated-body mt-4 mb-4 pt-2 pb-2">
                    <AddAddressModal show={this.state.showAddressModal} onHide={this.hideAddressModal}
                        onSuccess={this.onAddressChoose} />
                    <Container>
                        <Row>
                            <Col md={8}>
                                <div className="offer-dedicated-body-left">
                                    {/*<div className="bg-white rounded shadow-sm p-4 mb-4">
                            <h6 className="mb-3">You may also like</h6>
                            <ItemsCarousel />
                         </div>*/}
                                    <div className="pt-2"></div>
                                    <div className="bg-white rounded shadow-sm p-4 mb-4">
                                        <h4 className="mb-3">Geben Sie die Lieferinformationen ein</h4>
                                        {/* <h6 className="mb-3 text-black-50">Multiple addresses in this location</h6>*/}
                                        <Row>
                                            {/* <Col md={6}>
                                     <ChooseAddressCard 
                                           boxclassName="border border-success"
                                      title= 'Work'
                                      icoIcon= 'briefcase'
                                      iconclassName= 'icofont-3x'
                                      address= 'NCC, Model Town Rd, Pritm Nagar, Model Town, Ludhiana, Punjab 141002, India'
                                     />
                               </Col>
                               <Col md={6}>
                                     <ChooseAddressCard 
                                      title= 'Work'
                                      icoIcon= 'briefcase'
                                      iconclassName= 'icofont-3x'
                                      address= 'NCC, Model Town Rd, Pritm Nagar, Model Town, Ludhiana, Punjab 141002, India'
                                     />
                               </Col>*/}
                                            {/* <Col md={6}>
                                     <ChooseAddressCard 
                                      title= 'Lieferadresse'
                                      icoIcon= 'home'
                                      iconclassName= 'icofont-3x'
                                      address= 'Guido-Seeber-Weg 9, 14480 Potsdam'
                                     />
                               </Col>*/}
                                            <Col md={8}>
                                                <ChooseAddressCard
                                                    title='Neue Adresse'
                                                    icoIcon='home'
                                                    iconclassName='icofont-3x'
                                                    type="newAddress"
                                                    address=''
                                                    onAddNewClick={() => this.setState({ showAddressModal: true })}
                                                />
                                                {this.state.addresses}
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="pt-2"></div>
                                    <div className="bg-white rounded shadow-sm p-4 osahan-payment">
                                        <h4 className="mb-1">Zahlungsmethode wählen</h4>
                                        <h6 className="mb-3 text-black-50">PayPal/Bar</h6>
                                        <Tab.Container id="left-tabs-example" defaultActiveKey="third">
                                            <Row>
                                                <Col sm={4} className="pr-0">
                                                    <Nav variant="pills" className="flex-column">
                                                        {/*<Nav.Link eventKey="first"><Icofont icon="credit-card" /> Credit/Debit Cards</Nav.Link>*/}
                                                        {/*<Nav.Link eventKey="second"><Icofont icon="id-card" /> Food Cards</Nav.Link>*/}
                                                        <Nav.Link eventKey="third"
                                                            onClick={() => this.setPayment("paypal")}><Icofont
                                                                icon="paypal-alt" /> PayPal</Nav.Link>
                                                        {/*<Nav.Link eventKey="fourth"><Icofont icon="bank-alt" /> Netbanking</Nav.Link>*/}
                                                        <Nav.Link eventKey="fifth"
                                                            onClick={() => this.setPayment("bar")}><Icofont
                                                                icon="money" /> Bar</Nav.Link>
                                                    </Nav>
                                                </Col>
                                                <Col sm={8} className="pl-0">
                                                    <Tab.Content className='h-100'>
                                                        {/*<Tab.Pane eventKey="first">
                                      <h6 className="mb-3 mt-0 mb-3">Add new card</h6>
                                        <p>WE ACCEPT <span className="osahan-card">
                                           <Icofont icon="visa-alt" /> <Icofont icon="mastercard-alt" /> <Icofont icon="american-express-alt" /> <Icofont icon="payoneer-alt" /> <Icofont icon="apple-pay-alt" /> <Icofont icon="bank-transfer-alt" /> <Icofont icon="discover-alt" /> <Icofont icon="jcb-alt" />
                                           </span>
                                        </p>
                                        <Form>
                                           <div className="form-row">
                                              <Form.Group className="col-md-12">
                                                 <Form.Label>Card number</Form.Label>
                                                 <InputGroup>
                                                    <Form.Control type="number" placeholder="Card number" />
                                                    <InputGroup.Append>
                                                       <Button variant="outline-secondary" type="button" id="button-addon2"><Icofont icon="card" /></Button>
                                                    </InputGroup.Append>
                                                 </InputGroup>
                                              </Form.Group>
                                              <Form.Group className="col-md-8">
                                                 <Form.Label>Valid through(MM/YY)
                                                 </Form.Label>
                                                 <Form.Control type="number" placeholder="Enter Valid through(MM/YY)" />
                                              </Form.Group>
                                              <Form.Group className="col-md-4">
                                                 <Form.Label>CVV
                                                 </Form.Label>
                                                 <Form.Control type="number" placeholder="Enter CVV Number" />
                                              </Form.Group>
                                              <Form.Group className="col-md-12">
                                                 <Form.Label>Name on card
                                                 </Form.Label>
                                                 <Form.Control type="text" placeholder="Enter Card number" />
                                              </Form.Group>
                                              <Form.Group className="col-md-12">
                                                  <Form.Check 
                                                    custom
                                                    type="checkbox"
                                                    id="custom-checkbox1"
                                                    label="Securely save this card for a faster checkout next time."
                                                  />
                                              </Form.Group>
                                              <Form.Group className="col-md-12 mb-0">
                                                 <Link to="/thanks" className="btn btn-success btn-block btn-lg">PAY $1329
                                                     <Icofont icon="long-arrow-right" />
                                                 </Link>
                                              </Form.Group>
                                           </div>
                                        </Form>
                                    </Tab.Pane>*/}
                                                        {/*<Tab.Pane eventKey="second">
                                        <h6 className="mb-3 mt-0 mb-3">Add new food card</h6>
                                        <p>WE ACCEPT  <span className="osahan-card">
                                           <i className="icofont-sage-alt"></i> <i className="icofont-stripe-alt"></i> <i className="icofont-google-wallet-alt-1"></i>
                                           </span>
                                        </p>
                                        <Form>
                                           <div className="form-row">
                                              <Form.Group className="col-md-12">
                                                 <Form.Label>Card number</Form.Label>
                                                 <InputGroup>
                                                    <Form.Control type="number" placeholder="Card number" />
                                                    <InputGroup.Append>
                                                       <Button variant="outline-secondary" type="button" id="button-addon2"><Icofont icon="card" /></Button>
                                                    </InputGroup.Append>
                                                 </InputGroup>
                                              </Form.Group>
                                              <Form.Group className="col-md-8">
                                                 <Form.Label>Valid through(MM/YY)
                                                 </Form.Label>
                                                 <Form.Control type="number" placeholder="Enter Valid through(MM/YY)" />
                                              </Form.Group>
                                              <Form.Group className="col-md-4">
                                                 <Form.Label>CVV
                                                 </Form.Label>
                                                 <Form.Control type="number" placeholder="Enter CVV Number" />
                                              </Form.Group>
                                              <Form.Group className="col-md-12">
                                                 <Form.Label>Name on card
                                                 </Form.Label>
                                                 <Form.Control type="text" placeholder="Enter Card number" />
                                              </Form.Group>
                                              <Form.Group className="col-md-12">
                                                  <Form.Check 
                                                    custom
                                                    type="checkbox"
                                                    id="custom-checkbox"
                                                    label="Securely save this card for a faster checkout next time."
                                                  />
                                              </Form.Group>
                                              <Form.Group className="col-md-12 mb-0">
                                                 <Link to="/thanks" className="btn btn-success btn-block btn-lg">PAY $1329
                                                     <Icofont icon="long-arrow-right" />
                                                 </Link>
                                              </Form.Group>
                                           </div>
                                        </Form>
                                    </Tab.Pane>*/}
                                                        <Tab.Pane eventKey="third">
                                                            {/*<div className="border shadow-sm-sm p-4 d-flex align-items-center bg-white mb-3">
                                           <Icofont icon="apple-pay-alt" className="mr-3 icofont-3x" />
                                           <div className="d-flex flex-column">
                                              <h5 className="card-title">Apple Pay</h5>
                                              <p className="card-text">Apple Pay lets you order now & pay later at no extra cost.</p>
                                              <Link to="#" className="card-link font-weight-bold">LINK ACCOUNT <Icofont icon="link-alt" /></Link>
                                           </div>
                                        </div>*/}
                                                            <div
                                                                className="border shadow-sm-sm p-4 d-flex bg-white align-items-center mb-3">
                                                                {/*<Icofont icon="paypal-alt" className="mr-3 icofont-3x"/>*/}
                                                                <div className="d-flex flex-column">
                                                                    <h5 className="card-title">Paypal</h5>
                                                                    <p className="card-text"><p className="card-text">Das klappt über die Website von Paypal oder über die App.</p></p>
                                                                    {Object.keys(this.state.currentAddress) == 0 ? (
                                                                        <p>Wählen Sie eine Adresse.</p>) : (
                                                                        <p>Ausgewählte
                                                                            Adresse: {this.state.currentAddress.street} {this.state.currentAddress.houseNumber}, {this.state.currentAddress.zipCode} {this.state.currentAddress.city} {this.state.currentAddress.region}</p>
                                                                    )}
                                                                    <Link to="#"
                                                                        className={`btn btn-success btn-block btn-lg ${Object.keys(this.state.currentAddress) == 0 || this.state.paymentBusy ? 'disabled' : ''}`}
                                                                        onClick={this.sendOrder}>{this.state.paymentBusy ? 'WIRD VERARBEITET…' : `BEZAHLEN ${this.getTotalPrice()} €`}
                                                                        {/* <Icofont icon="long-arrow-right"/> */}</Link>
                                                                </div>
                                                            </div>
                                                            {/*<div className="border shadow-sm-sm p-4 d-flex bg-white align-items-center">
                                           <Icofont icon="diners-club" className="mr-3 icofont-3x" />
                                           <div className="d-flex flex-column">
                                              <h5 className="card-title">Diners Club</h5>
                                              <p className="card-text">Diners Club lets you order now & pay later at no extra cost.</p>
                                              <Link to="#" className="card-link font-weight-bold">LINK ACCOUNT <Icofont icon="link-alt" /></Link>
                                           </div>
                                        </div>*/}
                                                        </Tab.Pane>
                                                        {/*<Tab.Pane eventKey="fourth">
                                        <h6 className="mb-3 mt-0 mb-3">Netbanking</h6>
                                        <Form>
                                            <ButtonToolbar>
                                                <ToggleButtonGroup className="d-flex w-100" type="checkbox" name="options" defaultValue={1}>
                                                    <ToggleButton variant='info' value={1}>
                                                      HDFC <Icofont icon="check-circled" />
                                                    </ToggleButton>
                                                    <ToggleButton variant='info' value={2}>
                                                      ICICI <Icofont icon="check-circled" />
                                                    </ToggleButton>
                                                    <ToggleButton variant='info' value={3}>
                                                      AXIS <Icofont icon="check-circled" />
                                                    </ToggleButton>
                                                </ToggleButtonGroup>
                                            </ButtonToolbar>
                                            <hr />
                                            <div className="form-row">
                                              <Form.Group className="col-md-12">
                                                 <Form.Label>Select Bank
                                                 </Form.Label>
                                                 <br />
                                                 <Form.Control as="select" className="custom-select">
                                                  <option>Bank</option>
                                                  <option>One</option>
                                                  <option>Two</option>
                                                  <option>Three</option>
                                                 </Form.Control>
                                              </Form.Group>
                                              <Form.Group className="col-md-12 mb-0">
                                                 <Link to="/thanks" className="btn btn-success btn-block btn-lg">PAY $1329
                                                 <Icofont icon="long-arrow-right" /></Link>
                                              </Form.Group>
                                            </div>
                                        </Form>
                                    </Tab.Pane>*/}
                                                        <Tab.Pane eventKey="fifth">
                                                            <div className="border shadow-sm-sm p-4 bg-white mb-3">
                                                                <h5 className="mb-3 mt-0 mb-3">Barzahlung</h5>
                                                                <p>Bitte halten Sie das genaue Wechselgeld bereit, damit wir
                                                                    Sie besser bedienen können.</p>
                                                                {Object.keys(this.state.currentAddress) == 0 ? (
                                                                    <p>Wählen Sie eine Adresse.</p>) : (
                                                                    <p>Ausgewählte
                                                                        Adresse: {this.state.currentAddress.street} {this.state.currentAddress.houseNumber}, {this.state.currentAddress.zipCode} {this.state.currentAddress.city} {this.state.currentAddress.region}</p>
                                                                )}
                                                                <hr />
                                                                <Form>
                                                                    <Link to="#"
                                                                        className={`btn btn-success btn-block btn-lg ${Object.keys(this.state.currentAddress) == 0 || this.state.paymentBusy ? 'disabled' : ''}`}
                                                                        onClick={this.sendOrder}>{this.state.paymentBusy ? 'WIRD VERARBEITET…' : `BEZAHLEN ${this.getTotalPrice()} €`}
                                                                        {/* <Icofont icon="long-arrow-right"/>*/}</Link>
                                                                </Form>
                                                            </div>
                                                        </Tab.Pane>
                                                    </Tab.Content>
                                                </Col>
                                            </Row>
                                        </Tab.Container>
                                    </div>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="generator-bg rounded shadow-sm mb-4 p-4 osahan-cart-item">
                                    <div className="d-flex mb-4 osahan-cart-item-profile">
                                        <Image className="mr-3 float-left imgcontain img-fluid" style={{ fontSize: "0" }}
                                            alt={`Partner Logo ${this.state.lastRestaurant.name}`}
                                            src={this.state.lastRestaurant.logo} />
                                        <div className="d-flex flex-column p-1">
                                            <h6 className="mb-1 text-white">{this.state.lastRestaurant.name}</h6>
                                            <p className="mb-0 text-white"><Icofont
                                                icon="location-pin" /> {this.state.lastRestaurant.strasse} {this.state.lastRestaurant.hausnummer}, {this.state.lastRestaurant.plz} {this.state.lastRestaurant.ort}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="bg-white rounded shadow-sm mb-2">
                                        {this.state.productItems}
                                    </div>
                                    {/*<div className="mb-2 bg-white rounded p-2 clearfix">
                        <InputGroup className="input-group-sm mb-2">
                           <Form.Control type="text" placeholder="Enter promo code" />
                           <InputGroup.Append>
                              <Button variant="primary" type="button" id="button-addon2"><Icofont icon="sale-discount" /> APPLY</Button>
                           </InputGroup.Append>
                        </InputGroup>
                        <InputGroup className="mb-0">
                           <InputGroup.Prepend>
                              <InputGroup.Text><Icofont icon="comment" /></InputGroup.Text>
                           </InputGroup.Prepend>
                           <Form.Control as="textarea" placeholder="Any suggestions? We will pass it on..." aria-label="With textarea" />
                        </InputGroup>
                     </div>*/}
                                    {this.state.geschenkAktionen.filter(g => this.state.totalPrice >= parseFloat(g.mindestbestellwert)).length > 0 ? (
                                        <div className="mb-2 bg-white rounded p-2">
                                            <h6 className="text-success mb-1"><Icofont icon="gift" /> Geschenk!</h6>
                                            {this.state.geschenkAktionen.filter(g => this.state.totalPrice >= parseFloat(g.mindestbestellwert)).map(g => (
                                                <p key={g.id} className="mb-1">{g.geschenk_name}</p>
                                            ))}
                                        </div>
                                    ) : ''}
                                    <div className="mb-2 bg-white rounded p-2 clearfix">
                                        <p className="mb-1">Summe <span
                                            className="float-right text-dark">{this.state.totalPrice.toFixed(2)} €</span>
                                        </p>
                                        <p className="mb-1 text-success">Total Rabatt <span
                                            className="float-right text-success">{this.getDiscount()} €</span>
                                        </p>
                                        <p className="mb-1">Lieferkosten <span
                                            className="float-right text-dark">{this.state.lieferkosten.toFixed(2)} €</span>
                                        </p>
                                        <p className="mb-1">Summe Pfand <span
                                            className="float-right text-dark">{this.state.pfandPrice.toFixed(2)} €</span>
                                        </p>
                                        <hr />
                                        <h6 className="font-weight-bold mb-0">GESAMT <span
                                            className="float-right">{this.getTotalPrice()} €</span></h6>
                                        <p className="text-right" style={{ fontSize: "12px" }}>inkl. MwSt.</p>
                                    </div>
                                    <Link to="#"
                                        className={`btn btn-success btn-block btn-lg ${Object.keys(this.state.currentAddress) == 0 || this.state.paymentBusy ? 'disabled' : ''}`}
                                        onClick={this.sendOrder}>
                                        {this.state.paymentBusy ? 'WIRD VERARBEITET…' : `BEZAHLEN ${this.getTotalPrice()} €`}
                                        {/* <Icofont icon="long-arrow-right"/> */}</Link>
                                    {/* Bootstrap's .disabled sets pointer-events:none, so without an
                                        address selected this button silently swallowed every tap with
                                        no explanation at all - it simply looked broken. Say why. */}
                                    {Object.keys(this.state.currentAddress) == 0 ? (
                                        <div className="alert alert-warning mt-3 mb-0" role="alert">
                                            Bitte wählen Sie zuerst eine Lieferadresse aus, um fortzufahren.
                                        </div>
                                    ) : null}
                                    {this.state.paymentError ? (
                                        <div className="alert alert-danger mt-3 mb-0" role="alert">
                                            {this.state.paymentError}
                                        </div>
                                    ) : null}
                                </div>
                                {/*<div className="pt-2"></div>
                      <div className="alert alert-success" role="alert">
                         You have saved <strong>$1,884</strong> on the bill
                      </div>
                         <div className="pt-2"></div>
                         <div className="text-center pt-2">
                             <Image fluid src="https://dummyimage.com/352x504/ccc/ffffff.png&text=Google+ads" />
                         </div>*/}
                            </Col>
                        </Row>
                    </Container>
                </section>
            </>
        );
    }
}


export default Checkout;